import axios from '../../../commons/gdprcontrol-axios'

function getEventSkeleton () {
  return {
    id: null,
    organization: {
      id: null,
      name: ''
    },
    creator: {
      id: null,
      name: ''
    },
    partner: {
      id: null,
      name: ''
    },
    user: {
      id: null,
      name: ''
    },
    user_group: {
      id: null,
      name: ''
    },
    involved_users: [],
    subject: '',
    description: '',
    category: {
      id: null,
      name: ''
    },
    created_at: ''
  }
}

const state = {
  event: getEventSkeleton()
}

const getters = {
  getEvent: state => state.event
}

const actions = {
  fetchEvent: async ({ commit }, eventId) => {
    return axios.get(`/api/events/${eventId}/`)
      .then(response => {
        commit('setEvent', response.data)
      })
      .catch(error => {
        alert('Hiba az esemény letöltése közben')
        throw error
      })
  },

  saveNewEvent: async ({ commit, state }) => {
    return axios.post('/api/events/', state.event)
      .then(response => {
        commit('setEvent', response.data)
      })
      .catch(error => {
        alert('Hiba az esemény mentése közben')
        throw error
      })
  }
}

const mutations = {
  setEvent (state, event) {
    state.event = event
  },

  setAttribute (state, { name, value }) {
    state.event[name] = value
  },

  resetEvent (state) {
    state.event = getEventSkeleton()
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/events/details.js